// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3cI85","detailsBorder":"styles_detailsBorder__2XRJB"};